import * as React from 'react';
import { usePersonAccountsTAccEstimGloIntCur, usePersonAccountsCCurrencyTAccCode } from '../../hooks';
import { ActorApiNumberDisplayCurrency } from '../../../../../../components/display/number/currency';

export const PersonAccountsEstimGloIntCur = () => {
  const {
    data,
    isLoading,
    error,
  } = usePersonAccountsTAccEstimGloIntCur();
  const {
    data: currencyData,
    isLoading: currencyIsLoading,
    error: currencyError,
  } = usePersonAccountsCCurrencyTAccCode();
  return (
    <ActorApiNumberDisplayCurrency
      data={data}
      isLoading={isLoading}
      error={error}
      currencyData={currencyData}
      currencyIsLoading={currencyIsLoading}
      currencyError={currencyError}
    />
  );
};
